import { apiConfig } from "./apiConfig";
import {findHelpAddressBumper} from "./findHelpAddressBumper";
import {emptyAddressFilds} from "./emptyAddressFilds";
import { addressBumper } from "./addressBumper";
export function fullAddressRoundRobinApi(addressParam: any,roundRobin: any,successHandler:any,errorHandler:any){
    var conceptID = sessionStorage.getItem('conceptID');
    var apiUrl =   apiConfig.FranchiseLookUpByServiceAddress+'?&Address='+addressParam+'&IsRoundRobin='+roundRobin+'&conceptID='+conceptID+'&RequireAddressOnPartialPostalCode=true&apikey=' + window.DEFINE_VALUE.JS_API_KEY;
    if(addressBumper.addressBumperFlag) {
        addressBumper.addressBumperFlag = false;
    }
    $.ajax({
        type: "GET",
        url:apiUrl,
        contentType: "application/json",
        dataType: 'json',
        success: function(result){
            if(result.length==0){
                if(window.objOSGlobal.requestBodyValues.ConceptId=='25'){
                    document.querySelectorAll('.tab-pane.fieldset')?.forEach((tab)=>{
                        tab.classList.remove('active');
                    });
                    $('#hmsError').tab('show');
                    $('#hmsError .time-unavailable p').text(`We're sorry. We don't currently provide service to ${addressParam}`);
                    $('#hmsError .time-unavailable h2').text('');
                }else{
                    $('.scheduler-modal .modal-content').addClass('banner-wizard');
                    $(".tab-pane.fieldset").removeClass("active");
                    $('#no-search-result .head-title').html(`We're sorry. We don't currently provide service to <span class="noservice-zipcode">${window.objOSGlobal.requestBodyValues.PostalCode}</span>`);
                    $("#no-search-result").addClass("active");
                }
                localStorage.removeItem('zipcode');
            }else{
                window.objOSGlobal.paramsUI = {};
                window.objOSGlobal.requestBodyValues.WebLocationId = result[0].franchiseWebLocationId;
                window.objOSGlobal.requestBodyValues.FranchiseId = result[0].franchiseId;
                window.objOSGlobal.paramsUI.brandPhoneNumber = result[0].phoneNumber;
                window.objOSGlobal.paramsUI.doingBusinessAs = result[0].doingBusinessAs;
                window.objOSGlobal.requestBodyValues.licenseNumber = result[0].licenseNumber;
                successHandler();
            }
        },
        error: function(data){
            var duplicate = data.responseJSON; 
            if (duplicate?.Message == "Full address is needed to narrow down results"){
                findHelpAddressBumper(addressParam);
                $("#service-address-bumper .next").addClass("disble-btn").prop("disabled", true);
                $(".tab-pane.fieldset").removeClass("active");
                $('#service-address-bumper').addClass('active');
                $('.scheduler-modal .modal-content').addClass('banner-wizard');
                emptyAddressFilds();
            }else{
                if(window.objOSGlobal.requestBodyValues.ConceptCalledId =='25'){
                    $('.time-unavailable').addClass('center-error');
                    $('.time-unavailable h2').html('');
                    $('.time-unavailable h5').text('');
                    $('.time-unavailable p').text('We apologize for the technical issue. Please call us to complete your booking.');
                    $('.progressbar, .progress').hide();
                    document.querySelectorAll('.tab-pane').forEach((tab) =>
                    {
                        tab.classList.remove('active');
                    });
                    document.getElementById('hmsError').classList.add('active');
                }
            }
        }
    });
}